import React from 'react';

function Icon({icon, className="icon"}) {
  return (
      <span className={className}>
        <svg>
          <use xlinkHref={`/themes/custom/bluex/dist/assets/image/icons.svg#${icon}`}/>
        </svg>
      </span>
  );
}

export default Icon;